import { useEffect, useCallback } from 'react';
import { useQueryClient } from 'react-query';
import type { PushEventDetail, SilentPushEventDetail } from '../../../types/push';

export const usePushNotification = (chatRoomId?: string, type: 'chatMain' | 'dm' = 'dm') => {
  const queryClient = useQueryClient();

  // 푸시 타입별 핸들러
  const handleByPushType = useCallback(
    (detail: PushEventDetail) => {
      if (chatRoomId) {
        queryClient.invalidateQueries(['ChatRoomMessages', chatRoomId]);
        queryClient.invalidateQueries(['chatRoom', chatRoomId]);
      }

      if (type === 'chatMain') {
        queryClient.invalidateQueries(['AllChatRooms']);
      }

      queryClient.invalidateQueries(['unread_messages']);
      queryClient.invalidateQueries(['Notifications']);
    },
    [queryClient, chatRoomId, type]
  );

  useEffect(() => {
    // 일반 푸시 핸들러
    const handlePushMessage = (event: CustomEvent<PushEventDetail>) => {
      handleByPushType(event.detail);
    };

    // 사일런트 푸시 핸들러
    const handleSilentPush = (event: CustomEvent<SilentPushEventDetail>) => {
      handleByPushType(event.detail as PushEventDetail);
    };

    window.addEventListener('push:messageReceived', handlePushMessage as EventListener);
    window.addEventListener('push:silentReceived', handleSilentPush as EventListener);

    return () => {
      window.removeEventListener('push:messageReceived', handlePushMessage as EventListener);
      window.removeEventListener('push:silentReceived', handleSilentPush as EventListener);
    };
  }, [handleByPushType]);
};
